import api from 'api'
import { CACHE_TAG_CONTACT_VERSION_LIST, CACHE_TAG_CONTACT_VERSION_REFS } from 'api/cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    deactivateContacts: build.mutation({
      query: body => ({ url: '/api/account/contact/activate', method: 'POST', body }),
      invalidatesTags: (result, error, body) => {
        const tags = []
        // Collect contact ids from various common shapes
        const fromContactsArray = Array.isArray(result?.updatedContacts) ? result.updatedContacts.filter(Boolean) : []
        const contactIds = Array.from(new Set([...fromContactsArray]))
        for (const id of contactIds) tags.push({ type: CACHE_TAG_CONTACT_VERSION_LIST, id })
        const accountId = body?.accountId
        if (accountId) tags.push({ type: CACHE_TAG_CONTACT_VERSION_REFS, id: accountId })
        return tags
      },
    }),
  }),
})

export const { useDeactivateContactsMutation } = extendedApi
